import { render, staticRenderFns } from "./app.vue?vue&type=template&id=88705032&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&lang=css&"
import style1 from "./app.vue?vue&type=style&index=1&lang=css&"
import style2 from "./app.vue?vue&type=style&index=2&id=88705032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88705032",
  null
  
)

export default component.exports